var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMountain4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1276,
    height: 459,
    viewBox: "0 0 1276 459",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1003.53 72.9353C1080.29 37.0913 1351.56 -32.515 1429.86 18.6262V458.294H0.610596C0.610596 458.294 125.322 293.771 234 224C387.013 125.766 524.255 60.2632 683.561 102.805C842.868 145.347 907.586 117.74 1003.53 72.9353Z",
    fill: "url(#paint0_radial)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.5261 332.26) rotate(-3.27266) scale(1363.57 363.052)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A864D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222547,
    stopColor: "#4D2372"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.581608,
    stopColor: "#5673ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57BEF8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountain4);
export default __webpack_public_path__ + "static/media/mountain4.172e854ac941c22fc9163df52ec5c0f1.svg";
export { ForwardRef as ReactComponent };